<script lang="ts">
  import { analytics } from "$lib/analytics";
  import { user } from "$lib/user";
  import FilloutEmbed from "./FilloutEmbed.svelte";
  import MarketingButton from "./MarketingButton.svelte";

  let demoFormOpen = false;
</script>

<div class="flex flex-row gap-4 justify-center">
  <MarketingButton
    href={$user?.logged_in ? "/apps" : "/signup"}
    variant="primary"
    on:click={() => {
      analytics.track("Button Clicked", {
        text: "Get Started",
        url_path: "/",
      });
    }}
  >
    Get Started
  </MarketingButton>
  <MarketingButton
    on:click={() => {
      demoFormOpen = true;
      analytics.track("Button Clicked", {
        text: "Book a Demo",
        url_path: "/",
      });
    }}
  >
    Book a Demo
  </MarketingButton>
</div>

<FilloutEmbed
  formId="onUBuQZ5vCus"
  title="Book a demo form"
  open={demoFormOpen}
  on:close={() => (demoFormOpen = false)}
/>
